/**
 * Created by stonewang on 2017/8/29.
 */
import {config, request} from 'Utils';

export function getPreorderList(param) {
  return request(`${config.server}/api/v1/dms/tgReserveOrder/list`, {
    method: 'post',
    body: {...param},
  });
}
export function getDetail(param) {
  return request(`${config.server}/api/v1/dms/tgReserveOrder/detail`, {
    method: 'post',
    body: param,
  });
}
// /**
//  * 导出
//  * @param param
//  * @returns {*}
//  */
// export function exportId(params) {
//     return request(`${config.server}/api/v1/dms/tgReserveOrder/exportTgOrder?headerId=${params}`, {
//         method: 'get'
//     });
// }



// WEBPACK FOOTER //
// ./src/service/preOrder/index.js